export { PDFViewer } from './pdf-viewer';

export type { PDFViewerProps, DocumentPDF } from './pdf-viewer';
